export default __webpack_public_path__ + "static/media/flexline_logo_ee.9fb859c5.png";